// Whether this device has had the intro. It opens by itself once, the first time someone signed
// in lands on Home, and is marked seen when the player closes, watched or skipped.

const KEY = "pointz.introSeen";
const PROBE = "pointz.introProbe";

// Closed on this page already, whatever storage managed to keep.
let closedThisPage = false;

/** The device's storage, else this tab's when that is blocked; null when neither will hold a flag. */
function flagStore(): Storage | null {
  for (const get of [() => window.localStorage, () => window.sessionStorage]) {
    try {
      const store = get();
      store.setItem(PROBE, "1");
      store.removeItem(PROBE);
      return store;
    } catch {
      /* blocked or full: try the next */
    }
  }
  return null;
}

/**
 * True when the intro should open by itself. With nowhere to remember it, it would open on every
 * launch, so then it never opens by itself (Settings still plays it), the way blocked storage
 * celebrates no star rather than every one.
 */
export function shouldShowIntro(): boolean {
  if (closedThisPage) return false;
  try {
    const store = flagStore();
    return store !== null && store.getItem(KEY) === null;
  } catch {
    return false;
  }
}

export function markIntroSeen(): void {
  closedThisPage = true;
  try {
    flagStore()?.setItem(KEY, "1");
  } catch {
    /* the page flag above still keeps it from opening again until a reload */
  }
}
